import { render, staticRenderFns } from "./PlayerChatBlock.vue?vue&type=template&id=67e4e4bb&"
import script from "./PlayerChatBlock.vue?vue&type=script&lang=js&"
export * from "./PlayerChatBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports